import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import styles from "./store-details-wrapper.module.css";
import StoreMap from "../store-map";
import { StoreDetailsList } from "../store-details-list/store-details-list";
import { addBrackets } from "../../utils/capitalise-first-letter/add-brackets/add-brackets";
import { generateStoreType } from "@cinch-nx/landing-ui-shared";
export const StoreDetailsWrapper = ({ slug , latitude , longitude , address , phoneNumbers , openingHours  })=>{
    const { addressLine1 , addressLine2 , townOrCity , postCode  } = address;
    const storeAddress = [
        addressLine1,
        addressLine2,
        townOrCity,
        postCode
    ];
    const storeType = generateStoreType(slug);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                id: "store-details",
                className: styles.heading,
                children: `${slug} ${storeType} details`
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.storeWrapper,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.storeDetailsSectionWrapper,
                        children: [
                            /*#__PURE__*/ _jsx(StoreDetailsList, {
                                icon: "location",
                                title: "Where to find us",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    className: styles.storeAddress,
                                    children: storeAddress.map((item)=>{
                                        /*#__PURE__*/ return _jsx("li", {
                                            children: item === null || item === void 0 ? void 0 : item.toString()
                                        }, item === null || item === void 0 ? void 0 : item.toString());
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(StoreDetailsList, {
                                icon: "phone",
                                title: "Get in touch",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    children: phoneNumbers.map((item, index)=>{
                                        const hasPurpose = item.purpose.length > 0;
                                        return /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                item.phoneNumber,
                                                hasPurpose && ` ${addBrackets(item.purpose)}`
                                            ]
                                        }, index);
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(StoreDetailsList, {
                                icon: "time",
                                title: "Opening Hours",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    children: openingHours.map((item, index)=>/*#__PURE__*/ _jsxs("li", {
                                            className: styles.openingTimes,
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: styles.daysOfWeek,
                                                    children: item.daysOfWeek
                                                }),
                                                item.openingTime === "Closed" ? /*#__PURE__*/ _jsx("span", {
                                                    children: item.openingTime
                                                }) : /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        item.openingTime,
                                                        " - ",
                                                        item.closingTime
                                                    ]
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        className: styles.map,
                        children: /*#__PURE__*/ _jsx(StoreMap, {
                            coordinates: [
                                latitude,
                                longitude
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
